export const NewsletterContentText = ({children, style, align="Left", addClass=""}) => (
    <td className={"textContent" + (addClass ? ' ' + addClass : '')} align={align} valign="top" style={style}>
        {children}
    </td>
)

export default NewsletterContentText